import {createAction} from 'redux-actions';
import {getContentItemViewTitles} from '@pluto/rest';

export const GET_CONTENT_ITEM_VIEW_TITLES = 'GET_CONTENT_ITEM_VIEW_TITLES';

export const setContentItemViewTitles = createAction(
    GET_CONTENT_ITEM_VIEW_TITLES,
    async (id: number) => {
        return (await getContentItemViewTitles(id)) as any;
    }
);
